export default "__VITE_ASSET__CCkIiVuv__"